export default __webpack_public_path__ + "static/media/Inter-Black.e258f998.woff";